// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Alert = require("../../../../v5/common/Components/Alert.bs.js");
let React = require("react");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let ProfilePhotoInput = require("../../../../v5/common/ProfilePicture/ProfilePhotoInput.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let FragmentErrorBoundary = require("../../../../v5/common/ErrorHandling/FragmentErrorBoundary.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
let SharingProfileMiniFormProfilePhoto_agent_graphql = require("../../../../__generated__/SharingProfileMiniFormProfilePhoto_agent_graphql.bs.js");
let SharingProfileMiniFormProfilePhotoMutation_graphql = require("../../../../__generated__/SharingProfileMiniFormProfilePhotoMutation_graphql.bs.js");
let AvatarDefaultSvg = require("../../../../../assets/images/elements/avatar-default.svg");
let SharingProfileMiniFormProfilePhoto_currentPhoto_agent_graphql = require("../../../../__generated__/SharingProfileMiniFormProfilePhoto_currentPhoto_agent_graphql.bs.js");
let SharingProfileMiniFormProfilePhoto_changeProfilePhoto_agent_graphql = require("../../../../__generated__/SharingProfileMiniFormProfilePhoto_changeProfilePhoto_agent_graphql.bs.js");

let convertFragment = SharingProfileMiniFormProfilePhoto_currentPhoto_agent_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, SharingProfileMiniFormProfilePhoto_currentPhoto_agent_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(SharingProfileMiniFormProfilePhoto_currentPhoto_agent_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, SharingProfileMiniFormProfilePhoto_currentPhoto_agent_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(SharingProfileMiniFormProfilePhoto_currentPhoto_agent_graphql.node, convertFragment, fRef);
}

let Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

let avatarPlaceholder = AvatarDefaultSvg;

function SharingProfileMiniFormProfilePhoto$CurrentPhoto(props) {
  let agent = RescriptRelay_Fragment.useFragment(SharingProfileMiniFormProfilePhoto_currentPhoto_agent_graphql.node, convertFragment, props.agent);
  let profilePicture = agent.profilePhoto;
  let src = profilePicture !== undefined ? profilePicture.photoUrl : avatarPlaceholder;
  let match = agent.profilePhoto;
  let alt = match !== undefined ? "Your current profile picture" : "Placeholder profile picture showing a person's silhouette";
  return JsxRuntime.jsx("img", {
    className: "w-24 h-24 rounded-full",
    alt: alt,
    src: src
  });
}

let CurrentPhoto = {
  Fragment: Fragment,
  avatarPlaceholder: avatarPlaceholder,
  make: SharingProfileMiniFormProfilePhoto$CurrentPhoto
};

let convertFragment$1 = SharingProfileMiniFormProfilePhoto_changeProfilePhoto_agent_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, SharingProfileMiniFormProfilePhoto_changeProfilePhoto_agent_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(SharingProfileMiniFormProfilePhoto_changeProfilePhoto_agent_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, SharingProfileMiniFormProfilePhoto_changeProfilePhoto_agent_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(SharingProfileMiniFormProfilePhoto_changeProfilePhoto_agent_graphql.node, convertFragment$1, fRef);
}

let Fragment$1 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

let convertVariables = SharingProfileMiniFormProfilePhotoMutation_graphql.Internal.convertVariables;

let convertResponse = SharingProfileMiniFormProfilePhotoMutation_graphql.Internal.convertResponse;

let convertWrapRawResponse = SharingProfileMiniFormProfilePhotoMutation_graphql.Internal.convertWrapRawResponse;

let commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables, SharingProfileMiniFormProfilePhotoMutation_graphql.node, convertResponse, convertWrapRawResponse);

let use$2 = RescriptRelay_Mutation.useMutation(convertVariables, SharingProfileMiniFormProfilePhotoMutation_graphql.node, convertResponse, convertWrapRawResponse);

let Mutation_imageContentType_decode = SharingProfileMiniFormProfilePhotoMutation_graphql.Utils.imageContentType_decode;

let Mutation_imageContentType_fromString = SharingProfileMiniFormProfilePhotoMutation_graphql.Utils.imageContentType_fromString;

let Mutation = {
  imageContentType_decode: Mutation_imageContentType_decode,
  imageContentType_fromString: Mutation_imageContentType_fromString,
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  commitMutation: commitMutation,
  use: use$2
};

function SharingProfileMiniFormProfilePhoto$ChangeProfilePhoto(props) {
  let onNewPhotoSaved = props.onNewPhotoSaved;
  let agent = RescriptRelay_Fragment.useFragment(SharingProfileMiniFormProfilePhoto_changeProfilePhoto_agent_graphql.node, convertFragment$1, props.agent);
  let match = use$2();
  let mutate = match[0];
  let match$1 = agent.profilePhoto;
  let buttonText = match$1 !== undefined ? "Change photo" : "Add photo";
  return JsxRuntime.jsx(ProfilePhotoInput.make, {
    onSubmit: (param, param$1) => {
      let notifyOnError = param$1.notifyOnError;
      let notifyOnSuccess = param$1.notifyOnSuccess;
      mutate({
        input: {
          avatar: {
            croppedPhoto: param.croppedPhoto,
            originalPhoto: param.originalPhoto
          }
        }
      }, undefined, undefined, undefined, (response, errors) => {
        let match = response.updateAgentProfileAvatarV2;
        if (match !== undefined && match.__typename === "Agent" && errors === undefined) {
          notifyOnSuccess();
          return onNewPhotoSaved();
        } else {
          return notifyOnError("There was an error saving your photo. Please try again.");
        }
      }, param => notifyOnError("There was an error saving your photo. Please try again."), undefined);
    },
    onPhotoSelected: props.onNewPhotoSelected,
    buttonText: buttonText
  });
}

let ChangeProfilePhoto = {
  Fragment: Fragment$1,
  Mutation: Mutation,
  make: SharingProfileMiniFormProfilePhoto$ChangeProfilePhoto
};

let convertFragment$2 = SharingProfileMiniFormProfilePhoto_agent_graphql.Internal.convertFragment;

function waitForFragmentData$2(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, SharingProfileMiniFormProfilePhoto_agent_graphql.node, convertFragment$2, fRef);
}

function use$3(fRef) {
  return RescriptRelay_Fragment.useFragment(SharingProfileMiniFormProfilePhoto_agent_graphql.node, convertFragment$2, fRef);
}

function useOpt$2(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, SharingProfileMiniFormProfilePhoto_agent_graphql.node, convertFragment$2);
}

function readResolverFragment$2(fRef) {
  return RescriptRelay_Fragment.read(SharingProfileMiniFormProfilePhoto_agent_graphql.node, convertFragment$2, fRef);
}

let Fragment$2 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$2,
  waitForFragmentData: waitForFragmentData$2,
  use: use$3,
  useOpt: useOpt$2,
  readResolverFragment: readResolverFragment$2
};

function SharingProfileMiniFormProfilePhoto$WithoutErrorBundary(props) {
  let agent = RescriptRelay_Fragment.useFragment(SharingProfileMiniFormProfilePhoto_agent_graphql.node, convertFragment$2, props.agent);
  let match = React.useState(() => "InitialState");
  let setState = match[1];
  let tmp;
  tmp = match[0] === "InitialState" ? null : JsxRuntime.jsx(Alert.Success.make, {
      title: Stdlib_Option.getOr(agent.firstName, agent.displayName) + `'s photo was updated`
    });
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx(SharingProfileMiniFormProfilePhoto$CurrentPhoto, {
            agent: agent.fragmentRefs
          }),
          JsxRuntime.jsx(SharingProfileMiniFormProfilePhoto$ChangeProfilePhoto, {
            agent: agent.fragmentRefs,
            onNewPhotoSaved: () => setState(param => "Success"),
            onNewPhotoSelected: () => setState(param => "InitialState")
          })
        ],
        className: "mt-2 sm:mt-0 flex gap-6 items-center md:flex-col lg:flex-row"
      }),
      JsxRuntime.jsx("div", {
        children: tmp,
        className: "flex"
      })
    ],
    className: "sm:py-6 space-y-4"
  });
}

let WithoutErrorBundary = {
  make: SharingProfileMiniFormProfilePhoto$WithoutErrorBundary
};

function SharingProfileMiniFormProfilePhoto(props) {
  return JsxRuntime.jsx(FragmentErrorBoundary.make, {
    fragmentDisplayName: "Profile photo",
    children: JsxRuntime.jsx(SharingProfileMiniFormProfilePhoto$WithoutErrorBundary, {
      agent: props.agent
    })
  });
}

let make = SharingProfileMiniFormProfilePhoto;

exports.CurrentPhoto = CurrentPhoto;
exports.ChangeProfilePhoto = ChangeProfilePhoto;
exports.Fragment = Fragment$2;
exports.WithoutErrorBundary = WithoutErrorBundary;
exports.make = make;
/* avatarPlaceholder Not a pure module */
